import React, { useContext } from "react";
import { useState, useEffect } from "react";
// import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PasswordChecklist from "react-password-checklist";
import { Select2Data, formatDate, getPaginationMessage } from "../../../../utils/common";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import { Container, } from "react-bootstrap";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, } = useContext(Context);
  
  const id = props.show;
  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pincode, setPincode] = useState([]);

  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [iconCurrent, setIconCurrent] = useState(faEyeSlash);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  console.log(showModal,"showModal showModal");
  
  const GetEditData = async () => {
    const response = await getData(`/masters/investor/${id}`);
    reset(response?.data);
  };

  const GetAllCountries = async () => {
    const response = await getData("/without-login/masters/all-country");

    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };

  const GetAllStates = async (id) => {
    const response = await getData(`/without-login/masters/all-states/${id}`);

    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await getData(`/without-login/masters/all-city/${id}`);

    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };
  const GetAllPincode = async () => {
    const response = await getData(`/without-login/masters/all-occupation`);

    if (response?.success) {
      setPincode(await Select2Data(response?.data, "pincode_id"));
    }
  };

  useEffect(() => {
    GetAllPincode();
    GetEditData();
    GetAllCountries();
    GetAllStates();
    GetAllCities();
  }, []);
  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    } else if (field === "current_password") {
      setShowPasswordCurrent(!showPasswordCurrent);
      setIconCurrent(showPasswordCurrent ? faEyeSlash : faEye);
    }
  };
  const [password, setPassword] = useState("")
  const [passwordCurrent, setPasswordCurrent] = useState("")
  const [passwordAgain, setPasswordAgain] = useState("")
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    console.log(data);
    
    try {
      const finalData = new FormData();

      finalData.append("f_name", data.f_name);
      finalData.append("l_name", data.l_name);
      // finalData.append("password", data.re_password);
      const response = await postData(
        `/masters/investor/${id}`,
        finalData
      );
      console.log(response);
      if (response.success) {
        console.log("kkkkkkkkkkkk");
        
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
        }, 3000);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
    // if (data.re_password === data.c_password) {
    
    // } else {
    //   setError("password", {
    //     message: "Passwords must match",
    //   });
    // }
  };

  console.log(getValues(),"ggggggggggggggggggggg");
  
  return (
    <>
   <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add FAQ</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Edit Employee</Card.Title>
              <hr />
              <Container>
              <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>First Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="f_name"
                        placeholder="First Name"
                        className={classNames("", {
                          "is-invalid": errors?.f_name,
                        })}
                        {...register("f_name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.f_name && (
                      <span className="text-danger">
                        {errors.f_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Last Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="l_name"
                        placeholder="Last Name"
                        className={classNames("", {
                          "is-invalid": errors?.l_name,
                        })}
                        {...register("l_name", {
                          required: "Last Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.l_name && (
                      <span className="text-danger">
                        {errors.l_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

            

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />


    </>
  );
};

export default EditOffCanvance;
